import { ChangeEvent } from "react";

type InputProps = {
  label: string | any;
  value: string | number;
  required?: boolean;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void;
}

function Input({label, value, required, placeholder, error, onChange,disabled}: InputProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-black text-base flex justify-between items-center">
        {label}
        {required && <span className="text-[#BA0C2F]">*</span>}
      </label>

      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={`w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none placeholder:text-gray-400 bg-white shadow-custom ${
          disabled
              ? "!bg-[#E5E7EB] text-[#6B7280] border-[#DFE4EA] cursor-not-allowed"
              : "bg-white text-black border-[#DFE4EA]"
          }`}
      />

      {error && <span className="text-[#BA0C2F]">Заполните поле</span>}
    </div>
  )
}

export default Input;
